import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['localStorage', 'navigator'], 
      caches: ['localStorage'],           
    },
    fallbackLng: 'fr',                    
    lng: 'fr',                             
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: { translation: translationEN },
      fr: { translation: translationFR },
    },
  });
  

export default i18n;
